/**
 * each exported property must contain a function response()
 * exported proterty name is the command capitalized and with dot removed
 * @example "cdp.connection.find" === CdpConnectionFind
 *
 * if useMock is set to true mock HTTP Interceptor will try find the correspondent method *
 * if prorperty is present the method result of exported object will be executed with same parameters of the httpRequest
 *
 * if method return something it will be used instead of doing the http request
 */

import * as CdpEuiccAuditList from './cdp-euicc-audit-list';
import * as CdpEuiccFind from './cdp-euicc-find';
import * as CdpEuiccList from './cdp-euicc-list';
import * as CdpConnectionFind from './cdp-connection-find';
import * as CdpEuiccProfileSet_active from './cdp-euicc.profile.set_active';
import * as CdpEuiccProfileSet_fallback from './cdp-euicc.profile.set_fallback';
import * as CdpEuiccMnoList from './cdp-euicc-mno-list';
import * as CdpRadiusList from './cdp-radius-list';
import * as LocationHistory from './location-history';
import * as CdpEuiccRefresh from './cdp-euicc-refresh';

export const MockData = {
    CdpEuiccAuditList,
    CdpEuiccList,
    CdpConnectionFind,
    CdpEuiccFind,
    CdpEuiccProfileSet_fallback,
    CdpEuiccProfileSet_active,
    CdpEuiccMnoList,
    CdpEuiccRefresh,
    CdpRadiusList,
    LocationHistory
}
